export default __webpack_public_path__ + "static/media/about-video-bg-orange.2fc0bfe9.png";